import SEO from "@/components/SEO";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import WhyAurora from "@/components/WhyAurora";
import HowItWorks from "@/components/HowItWorks";
import FAQ from "@/components/FAQ";
import WaitlistSection from "@/components/WaitlistSection";
import Footer from "@/components/Footer";

// LCP image - the first/largest property image that loads above the fold
const LCP_IMAGE = "https://ufzgcwxmtjfyghggvavu.supabase.co/storage/v1/object/public/property-images/North West Retail Park - Aur0ra Property-optimized.jpg";

// FAQPage structured data for SEO
const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is AurØra?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "AurØra is a platform that provides structured, on-chain access to income generated by professionally managed property in the United Kingdom. Access is delivered through income rights, not property ownership."
      }
    },
    {
      "@type": "Question",
      "name": "What do AurØra tokens represent?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Tokens represent contractual rights to income generated by the underlying property portfolio. They do not represent ownership of property, equity, or governance rights."
      }
    },
    {
      "@type": "Question",
      "name": "Do I own property through AurØra?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. Participation does not involve owning property or having control over assets. AurØra manages acquisition, financing, and operations."
      }
    },
    {
      "@type": "Question",
      "name": "How is income generated and tracked?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Income is generated from rental operations across the portfolio and tracked through on-chain infrastructure, providing transparent reporting and allocation."
      }
    },
    {
      "@type": "Question",
      "name": "Is leverage used?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Leverage may be applied at the asset level where appropriate to improve capital efficiency. Participants are not personally leveraged."
      }
    },
    {
      "@type": "Question",
      "name": "Who manages the properties?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "All properties are professionally managed by experienced operators under AurØra's oversight and discipline framework."
      }
    },
    {
      "@type": "Question",
      "name": "Who can access AurØra?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "AurØra is designed for a global audience, subject to applicable laws and platform requirements. Access may vary by jurisdiction."
      }
    },
    {
      "@type": "Question",
      "name": "What risks are involved?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Participation involves risk. Income is variable, property performance can change, and outcomes are not guaranteed. Users should review the Risk Disclosure before participating."
      }
    }
  ]
};

const Index = () => {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <SEO 
        title="AurØra – Global Property Income"
        description="Earn diversified property income through a single, liquid portfolio. No ownership, no management — just property income delivered through modern financial infrastructure."
        canonical="/"
        preloadImage={LCP_IMAGE}
        jsonLd={faqJsonLd}
      />
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      <Navbar />
      <main id="main-content" role="main" aria-label="Main content">
        <HeroSection />
        <WhyAurora />
        <HowItWorks />
        <FAQ />
        <WaitlistSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
